import {createApi} from '@reduxjs/toolkit/query/react';
import {axiosBaseQuery} from '@/helpers/axiosBaseQuery';
import api from '@/store/api/api';

export const templatesApi = createApi({
    reducerPath: 'templatesApi',
    tagTypes: ['templates'],
    baseQuery: axiosBaseQuery({
        baseUrl: api.root,
    }),
    endpoints: (build) => ({
        getTemplates: build.query({
            query: (params) => ({
                url: api.templates.getTemplates(),
                method: 'GET',
                params,
            }),
            serializeQueryArgs: ({endpointName, queryArgs}) => {
                return [endpointName, queryArgs?.location_id, queryArgs?.storage_id]
            },
            merge: (currentCache, newItems, {arg}) => {
                if (arg.skip === 0) {
                    return newItems;
                }
                currentCache.push(...newItems.filter((newItem) => !currentCache.some((item) => item.id === newItem.id)))
            },
            forceRefetch: ({currentArg, previousArg}) => {
                return currentArg !== previousArg;
            },
        }),
        createTemplate: build.mutation({
            query: (body) => ({
                url: api.templates.createTemplate(),
                method: 'POST',
                body,
            }),
            async onQueryStarted(newTemplate, {dispatch, queryFulfilled}) {
                try {
                    const {data} = await queryFulfilled;
                    const changedData = {
                        ...data, ...newTemplate
                    }
                    dispatch(
                        templatesApi.util.updateQueryData('getTemplates', {
                            location_id: newTemplate.location_id,
                            storage_id: newTemplate.storage_id
                        }, (draft) => {
                            draft.unshift(changedData);
                        })
                    );
                } catch (error) {
                    console.error('Failed to update cache after creating template:', error);
                }
            }
        }),
        updateTemplate: build.mutation({
            query: ({id, ...body}) => ({
                url: api.templates.updateTemplate(id),
                method: 'PUT',
                body,
            }),
            async onQueryStarted(updatedTemplate, {dispatch, queryFulfilled}) {
                try {
                   const data =  await queryFulfilled;
                    dispatch(
                        templatesApi.util.updateQueryData('getTemplates', {
                            location_id: updatedTemplate.location_id,
                            storage_id: updatedTemplate.storage_id
                        }, (draft) => {
                            const index = draft.findIndex(item => {
                                return item.id === updatedTemplate.id
                            });
                            if (index !== -1) {
                                draft[index] = data.data;
                            }
                        })
                    );
                } catch (error) {
                    console.error('Failed to update cache after editing template:', error);
                }
            }
        }),
        deleteTemplate: build.mutation({
            query: ({id, ...data}) => ({
                url: api.templates.deleteTemplate(id),
                method: 'DELETE',
                params: data,
            }),
            async onQueryStarted(patch, {dispatch, queryFulfilled}) {
                try {
                    await queryFulfilled
                    dispatch(
                        templatesApi.util.updateQueryData('getTemplates', {
                            location_id: patch.location_id,
                            storage_id: patch.storage_id
                        }, (draft) => {
                            const index = draft.findIndex((template) => template.id === patch.id);
                            if (index !== -1) {
                                draft.splice(index, 1)
                            } else {
                                console.warn('template not found in cache')
                            }
                        })
                    );
                } catch (e) {
                    console.error('Delete failed:', e)
                }
            },
        }),
    }),
});

export const {
    useLazyGetTemplatesQuery,
    useLazyCreateTemplateMutation,
} = templatesApi;